import angular from 'angular';

import engineerModule from './screens/engineer';
import guestModule from './screens/guest';
import loginModule from './screens/login';
import restorePasswordModule from './screens/restore-password';
import env from 'env';
import appConfig from './app.config';
import loaderComponent from 'loader';
import DeviceService from 'device.service';
import AuthService from 'auth.service';
import appComponent from './app.component';

let appModule = angular.module('app', [
  engineerModule.name,
  guestModule.name,
  loginModule.name,
  restorePasswordModule.name,
])
  .constant('ENV', env)
  .config(appConfig)
  .service('Device', DeviceService)
  .service('Auth', AuthService)
  .component('loader', loaderComponent)
  .component('app', appComponent)

export default appModule;



// WEBPACK FOOTER //
// ./src/app/index.js